module.exports = __webpack_public_path__ + "static/media/Bmm.cf7690b3.svg";